import { Footer, Paragraph, TextRun, AlignmentType, PageNumber } from 'docx';

/**
 * Footer chuẩn cho DOCX xuất từ SPA: đánh số trang (Trang X / Y) + watermark tùy chọn.
 */
export function buildDocxFooterWithPageNumbers(options: { showWatermark: boolean }): Footer {
  const children = [
    new Paragraph({
      alignment: AlignmentType.CENTER,
      children: [
        new TextRun({ text: 'Trang ' }),
        new TextRun({ children: [PageNumber.CURRENT] }),
        new TextRun({ text: ' / ' }),
        new TextRun({ children: [PageNumber.TOTAL_PAGES] }),
      ],
    }),
  ];
  if (options.showWatermark) {
    children.push(
      new Paragraph({
        alignment: AlignmentType.RIGHT,
        children: [
          new TextRun({
            text: 'Powered by Bookai.vn',
            italics: true,
            color: '94A3B8',
            size: 18,
            font: 'Times New Roman',
          }),
        ],
      }),
    );
  }
  return new Footer({ children });
}
